import { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogActions, DialogTitle, Slide, Stack, Tooltip } from "@mui/material";
import Header from "../../components/Header";
import DebFormModal from "../../components/DebFormModal";
import { DebFormSelect, DebFormTextInput } from "../../components/DebFormComponents";
import DataTable from "../../components/DataTable";
import { branch } from "../../services/branches";
import AddBoxIcon from "@mui/icons-material/AddBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack";
import { branchValidationSchema } from "../../schemas/branch";
import { company } from "../../services/companies";
import {countries} from "../../constants/countries";


//TRANSICIÓN DEL ALERT DE ELIMINACIÓN
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const newBranchValues = {
    name: "",
    direccion: "",
    estado: "",
    pais: "",
    latitude: "",
    longitude: "",
    company: {
        id: "",
    },
};

const Branches = () => {
    // MODAL DE EDICIÓN / CREACIÓN
    const [modalState, setModalState] = useState(false);
    const [modalInitialValues, setModalInitialValues] =
        useState(newBranchValues);
    const [branches, setBranches] = useState([]);
    const [companies, setCompanies] = useState([]);

    const getBranches = async () => {
        setBranches(await branch.getAll());
    };
    const getCompanies = async () => {
        setCompanies(await company.getAll());
    };

    useEffect(() => {
        getBranches();
        getCompanies();
    }, []);

    const { enqueueSnackbar } = useSnackbar();

    const modifiedBranches = [...branches].map((branch) => ({
        ...branch,
        companyName: branch.company.name
    }))

    const handleSubmit = async (values) => {
        try {
            if (values.id) {
                //estamos editando
                const res = await branch.update(values);
                enqueueSnackbar("Sucursal editada", {
                    preventDuplicate: true,
                    variant: "success",
                });
            } else {
                const res = await branch.create(values);
                enqueueSnackbar("Sucursal creada", {
                    preventDuplicate: true,
                    variant: "success",
                });
            }
            closeModal();
            getBranches();
        } catch (error) {
            if (values.id) {
                enqueueSnackbar("Ocurrió un error al editar la sucursal", {
                    preventDuplicate: true,
                    variant: "error",
                });
            } else {
                enqueueSnackbar("Ocurrió un error al crear la sucursal", {
                    preventDuplicate: true,
                    variant: "error",
                });
            }
        }
    };

    const openModal = () => {
        setModalState(true);
    };

    const closeModal = () => {
        setModalState(false);
        setModalInitialValues(newBranchValues);
    };

    const handleEdit = (branch) => {
        setModalInitialValues(branch);
        openModal();
    };
    const handleCreateBranch = () => {
        setModalInitialValues(newBranchValues);
        openModal();
    };

    
      // ALERT DE ELIMINACIÓN
      const [selectedDelete, setSelectedDelete] = useState();
      const [openAlert, setOpenAlert] = useState(false);
      const handleAlertClose = () => {
          setOpenAlert(false);
      };
      const handleAlertOpen = (selectedBranch) => {
        setSelectedDelete(selectedBranch);
        setOpenAlert(true);
      };

    const handleDelete = async () => {
        try {
            const res = await branch.delete(selectedDelete.id);
            enqueueSnackbar("Se eliminó la sucursal " + selectedDelete.name, {
                preventDuplicate: true,
                variant: "success",
            });
            handleAlertClose();
            getBranches();
        } catch (error) {
            enqueueSnackbar("Ocurrió un error eliminando la sucursal", {
                preventDuplicate: true,
                variant: "error",
            });
        }
    };

    const columns = [
        { field: "id", headerName: "ID", flex: 0.1 },
        {
            field: "name",
            headerName: "Nombre",
            flex: 0.7,
            renderCell: (params) => (
                <Tooltip title={params?.value ?? ""} arrow>
                    <span className="table-cell-trucate">{params?.value ?? ""}</span>
                </Tooltip>
            ),
        },
        {
            field: "direccion",
            headerName: "Dirección",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params?.value ?? ""} arrow>
                    <span className="table-cell-trucate">{params?.value ?? ""}</span>
                </Tooltip>
            ),
        },
        {
            field: "estado",
            headerName: "Estado",
            flex: 0.9,
            renderCell: (params) => (
                <Tooltip title={params?.value ?? ""} arrow>
                    <span className="table-cell-trucate">{params?.value ?? ""}</span>
                </Tooltip>
            ),
        },
        {
            field: "pais",
            headerName: "País",
            flex: 0.8,
            renderCell: (params) => (
                <Tooltip title={params?.value ?? ""} arrow>
                    <span className="table-cell-trucate">{params?.value ?? ""}</span>
                </Tooltip>
            ),
        },
        {
            field: "latitude",
            headerName: "Latitud",
            flex: 0.5,
        },
        {
            field: "longitude",
            headerName: "Longitud",
            flex: 0.5,
        },
        {
            field: "companyName",
            headerName: "Compañía",
            flex: 1,
            renderCell: (params) => {
                return params?.row?.companyName ?? "";
            },
        },
    ];

    return (
        <Box>
            <Header title="SUCURSALES" subtitle="Lista de Sucursales"/>
            <DataTable
                loading={!branches.length}
                rows={modifiedBranches}
                columns={columns}
                rowActions={[
                    {
                        label: "Editar",
                        icon: <EditIcon />,
                        action: handleEdit,
                    },
                    /*{
                        label: "Eliminar",
                        icon: <DeleteIcon />,
                        action: handleAlertOpen,
                        showInMenu: true,
                    },*/
                ]}
                headerActions={[
                    {
                        label: "Crear Sucursal",
                        icon: <AddBoxIcon />,
                        action: handleCreateBranch,
                    },
                ]}
            />

            {/* MODAL DE CREACIÓN / EDICIÓN DE COMPAÑÍA */}
            <DebFormModal
                maxWidth="sm"
                fullWidth={true}
                open={modalState}
                onClose={closeModal}
                onReject={closeModal}
                initialValues={modalInitialValues}
                onSubmit={handleSubmit}
                formikProps={{
                    enableReinitialize: true,
                    validationSchema: branchValidationSchema,
                }}
                headerText={
                    modalInitialValues?.id
                        ? "Editar Sucursal"
                        : "Crear Sucursal"
                }>
                <Stack spacing={1}>
                    <DebFormTextInput label={"Nombre"} name={"name"} />
                    <DebFormTextInput label={"Dirección"} name={"direccion"} />
                    <DebFormTextInput label={"Estado"} name={"estado"} />
                    <DebFormSelect
                        label={"País"}
                        name={"pais"}
                        selectOptions={countries}
                    />
                    <DebFormTextInput label={"Latitud"} name={"latitude"} />
                    <DebFormTextInput label={"Longitud"} name={"longitude"} />
                    <DebFormSelect
                        label={"Compañía"}
                        name={"company.id"}
                        selectOptions={Array.from(companies)?.map((company) => {
                            return {
                                value: company.id,
                                label: company.name,
                            };
                        })}
                    />
                </Stack>
            </DebFormModal>
            
            {/* ALERT DE ELIMINACIÓN */}
            <Dialog
                open={openAlert}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleAlertClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle sx={{m:"2rem 3rem 1rem 3rem", gap:"1rem", p:"0"}} >{"¿Esta seguro que desea eliminar?"}</DialogTitle>
                <DialogActions>
                <Button onClick={handleAlertClose} variant="outlined" color="error">Cancelar</Button>
                <Button onClick={handleDelete} variant="contained" color="success">Confirmar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Branches;
